import type { SVGProps } from 'react';
const SvgChevronStart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.666 5.027a1 1 0 0 0-.18.077c-.067.038-.78.733-3.102 3.025a317 317 0 0 0-3.11 3.091 1.13 1.13 0 0 0-.273.729c-.01.29.049.51.201.74.1.15 6.085 6.073 6.246 6.18a.7.7 0 0 0 .42.13.78.78 0 0 0 .645-.246.815.815 0 0 0 .153-.952l-.062-.126-2.869-2.837L6.866 12l2.869-2.837 2.869-2.837.062-.126a.8.8 0 0 0 .08-.494.86.86 0 0 0-.6-.68 1.1 1.1 0 0 0-.48 0m6.245 0a1 1 0 0 0-.18.077c-.068.038-.78.733-3.102 3.025a316 316 0 0 0-3.11 3.091 1.13 1.13 0 0 0-.273.729c-.011.29.048.51.2.74.1.15 6.086 6.073 6.247 6.18a.7.7 0 0 0 .42.13c.188.008.32-.02.456-.098a.83.83 0 0 0 .341-1.1l-.062-.126-2.868-2.837L13.11 12l2.87-2.837 2.868-2.837.062-.126a.8.8 0 0 0 .08-.494.85.85 0 0 0-.6-.68 1.1 1.1 0 0 0-.48 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronStart;
